import { ReportNotFound } from '@/features/reports/ReportView';
import { ReportsLayout } from '@/features/reports/ReportsLayout';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/reports')({
  staticData: { nav: 'reports' },
  component: ReportsLayout,
  // An id outside the seven throws notFound() in /reports/$reportId; it shows under the area's header.
  notFoundComponent: ReportNotFound,
});
